import { TabStyles } from '@tableau/widgets';
import { HeaderColumn } from '@tableau/widgets-datagrid';
import React from 'react';
import { SvgCertifiedIconColumnHeader } from '../../../../../../gen-src/icons';
import { WarningColumnHeaderIcon } from '../../labels/LabelIcons';
import { divWithStyle } from '../../style/LayoutComponents';


// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
const IconHeader = divWithStyle('IconCell', {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: TabStyles.Spacing.ExtraLargeSpace,
  paddingLeft: TabStyles.Spacing.MediumSpace - 1,
  paddingRight: TabStyles.Spacing.MediumSpace,
});

function IconHeaderFormatter() {
  return (
    <IconHeader>
      <WarningColumnHeaderIcon />
    </IconHeader>
  );
}

function CertificationIconHeaderFormatter() {
  return (
    <IconHeader>
      <SvgCertifiedIconColumnHeader />
    </IconHeader>
  );
}

export const DataQualityIconHeaderFormatterFactory = React.createFactory<HeaderColumn.HeaderFormatterProps>(IconHeaderFormatter);

export const DataQualityIconHeaderCertificationFormatterFactory = React.createFactory<HeaderColumn.HeaderFormatterProps>(CertificationIconHeaderFormatter);

export const SensitivityHeaderFormatterFactory = React.createFactory<HeaderColumn.HeaderFormatterProps>(IconHeaderFormatter);
